import Choices from 'choices.js';
class ModuleSidebarCompany {

  private selectThemes!: HTMLSelectElement;

  constructor() {
    this._init();
  }

  _init() {
    this.selectThemes = document.querySelector(".sidebar-company__custom-select__input") as HTMLSelectElement;
    if (this.selectThemes) {
      this._openClose();
      this._select();
      this._valid();
    }
  }

  _select() {
    const options = Array.from(this.selectThemes.options).map(option => ({
      value: option.value,
      label: option.text,
      selected: option.selected,
      customProperties: {
        logo: option.getAttribute('data-logo'),
      },
    }));

    const customTemplates = (template: Function) => ({
      item: ({ classNames }: any, data: any) => {
        return template(`
              <div class="${classNames.item} ${(data.highlighted ? classNames.highlightedState : classNames.itemSelectable).join(' ')}" 
                   data-value="${data.value}" data-id="${data.id}" ${data.active ? 'aria-selected="true"' : ''
          } ${data.disabled ? 'aria-disabled="true"' : ''}>
                  <img src="${data.customProperties.logo}" alt="${data.label}">
                  <span class="select-label">${data.label}</span>
              </div>
          `);
      },
      choice: ({ classNames }: any, data: any) => {
        return template(`
              <div class="${classNames.item} ${classNames.itemSelectable} ${(classNames.itemChoice).join(' ')} ${(data.disabled ? classNames.itemDisabled : classNames.itemSelectable).join(' ')}" 
                   data-value="${data.value}" data-id="${data.id}" data-choice ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'}>
                  <img src="${data.customProperties.logo}" alt="${data.label}">
                  <span class="select-label">${data.label}</span>
              </div>
          `);
      },
    });

    const choix = new Choices(this.selectThemes, {
      searchEnabled: false,
      itemSelectText: '',
      shouldSort: false,
      callbackOnCreateTemplates: customTemplates,
      choices: options,
    });
  }


  _valid() {
    const validButton = document.querySelector('[data-valid-sidebar-company]') as HTMLButtonElement;
    validButton.addEventListener('click', (e) => {
      e.preventDefault();
      const currentUrl = new URL(window.location.href);
      const baseUrl = `${currentUrl.origin}${currentUrl.pathname.split('/').slice(0, 2).join('/')}`;
      currentUrl.href = baseUrl;
      currentUrl.searchParams.set('theme', this.selectThemes.value.replace('theme_', ''));
      window.location.href = currentUrl.href;
    })
  }

  _openClose() {
    const sidebar_company_close = document.querySelectorAll(
      '[data-close-sidebar-company]'
    );

    if (sidebar_company_close) {
      sidebar_company_close.forEach((close) => {
        close.addEventListener('click', this._hideSidebar.bind(this));
      });
    }
  }

  _hideSidebar() {
    const sidebar_company = document.getElementById('sidebar-company');
    if (sidebar_company && sidebar_company.classList.contains('open')) {
      sidebar_company.classList.remove('open');
      document.body.classList.remove('sidebar-open');
    }
  }
}

export const moduleSidebarCompany = new ModuleSidebarCompany();


